import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { LayoutService } from '@commons/core/ui/layout.service';
import { Actions, ofType } from '@ngrx/effects';

import { MessagingAction, MessagingStatus } from '@contact/upgrade';

export const run = [
  'ngrxActionService',
  'httpDeprecated',
  'layoutService',
  (actions$: Actions, httpDeprecated: HttpDeprecatedService, layoutService: LayoutService) => {
    layoutService.loadCacheTemplate().subscribe();

    // Subscriber executed when messaging can't reconnect due to session expiration on server.
    actions$.pipe(ofType(MessagingAction.EmitEvent)).subscribe(({ event }) => {
      if (event.status === MessagingStatus.DISCONNECTED) {
        // add a trace server side to known user has lost cometd connection
        // and popin will be displayed if we cannot recreate a session and reconnect to cometd
        httpDeprecated
          .asPromise()
          .withConfig({ headers: { 'Content-Type': 'text/plain; charset=UTF-8' } })
          .withData('MESSAGING_CONNECTION_DISCONNECTED')
          .post('protected/user/traceToServerLogs', ['WARN', 'ANGULAR']);
      } else if (event.status === MessagingStatus.LOST) {
        // add a trace server side to known user has temporary lost cometd connection
        httpDeprecated
          .asPromise()
          .withConfig({ headers: { 'Content-Type': 'text/plain; charset=UTF-8' } })
          .withData('MESSAGING_CONNECTION_LOST')
          .post('protected/user/traceToServerLogs', ['WARN', 'ANGULAR']);
      }

      if (event.message) {
        // add a trace server side to known message content which was not successful or message that should end timer and does not
        httpDeprecated
          .asPromise()
          .withConfig({ headers: { 'Content-Type': 'text/plain; charset=UTF-8' } })
          .withData(`${event.status}:${event.message}`)
          .post('protected/user/traceToServerLogs', ['WARN', 'ANGULAR']);
      }
    });
  },
];
